export default __webpack_public_path__ + "static/voterfraud-991ebc22ea0504f63ae94f6365d2d22f.png";